export const createFormWithPostCard = async (canvas: HTMLCanvasElement) => {
  const blob = await new Promise(resolve => {
    canvas.toBlob(resolve, 'image/png', 1.0);
  });

  const form = new FormData();
  form.append('file', blob as Blob, 'mainHero.png');

  return form;
};
